module.exports = __webpack_public_path__ + "img/a1.48f92d03.png";